export const environment = {
    production: false,
    env: 'dev',
    APIEndpoint: window.localStorage.getItem('apiUrl'),
    version: window.localStorage.getItem('version')
  };
  